import React, { useCallback, useEffect, useState, useRef } from 'react';
import { ShoppingCart } from 'lucide-react';
const buyers = [{
  name: 'Valentina',
  city: 'Buenos Aires'
}, {
  name: 'Matías',
  city: 'Córdoba'
}, {
  name: 'Camila',
  city: 'Rosario'
}, {
  name: 'Lucas',
  city: 'Mendoza'
}, {
  name: 'Sofía',
  city: 'Tucumán'
}, {
  name: 'Nicolás',
  city: 'La Plata'
}, {
  name: 'Martina',
  city: 'Mar del Plata'
}, {
  name: 'Joaquín',
  city: 'Santa Fe'
}, {
  name: 'Florencia',
  city: 'Salta'
}, {
  name: 'Tomás',
  city: 'Neuquén'
}, {
  name: 'Agustina',
  city: 'Bahía Blanca'
}, {
  name: 'Santiago',
  city: 'Paraná'
}];
function getRandomBuyer() {
  return buyers[Math.floor(Math.random() * buyers.length)];
}
function getRandomMinutes() {
  return Math.floor(Math.random() * 10) + 1;
}
export function LivePurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(getRandomBuyer());
  const [minutes, setMinutes] = useState(getRandomMinutes());
  const timeoutsRef = useRef<number[]>([]);
  const addTimeout = useCallback((fn: () => void, delay: number) => {
    const id = window.setTimeout(fn, delay);
    timeoutsRef.current.push(id);
    return id;
  }, []);
  const showNotification = useCallback(() => {
    setBuyer(getRandomBuyer());
    setMinutes(getRandomMinutes());
    setVisible(true);
    addTimeout(() => {
      setVisible(false);
      const nextDelay = (Math.random() * 7 + 8) * 1000;
      addTimeout(() => {
        showNotification();
      }, nextDelay);
    }, 4000);
  }, [addTimeout]);
  useEffect(() => {
    const id = window.setTimeout(() => {
      showNotification();
    }, 5000);
    timeoutsRef.current.push(id);
    return () => {
      timeoutsRef.current.forEach(tid => window.clearTimeout(tid));
      timeoutsRef.current = [];
    };
  }, [showNotification]);
  return <div className={`fixed bottom-20 md:bottom-6 left-4 z-40 transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-2">
      <div className="bg-slate-800 border border-slate-700 rounded-xl px-4 py-3 shadow-2xl flex items-center gap-3 max-w-xs" data-id="element-3">
        <div className="w-9 h-9 bg-green-500/20 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-4">
          <ShoppingCart className="w-4 h-4 text-green-400" data-id="element-5" />
        </div>
        <div data-id="element-6">
          <p className="text-white text-sm font-semibold leading-tight" data-id="element-7">
            {buyer.name} de {buyer.city}
          </p>
          <p className="text-slate-400 text-xs mt-0.5" data-id="element-8">
            compró el curso hace {minutes} min
          </p>
        </div>
      </div>
    </div>;
}